import { Avatar, Box, Divider, Stack, Typography } from '@mui/material'
import React from 'react'

function FlowChart({ index }) {
    const cn = {

        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",

    }
    const bn = {
        width: 24,
        height: 24,
        bgColor: "#15513c",
        color: "#eee"
    }


    return (
        <>
            <Stack sx={{ width: "150px" }} alignItems={"center"} justifyContent={"center"}>

                <Box sx={cn}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: index >= 1 ? "#15513c" : "#777", color: "#Eee" }}>1</Avatar>
                    <Typography sx={{ color: index > 1 ? "#15513c" : "#777" }}>المعلومات الشخصية</Typography>
                    <Divider orientation="vertical" variant="middle" sx={{ bgcolor: index > 1 ? "#15513c" : "#777", height: "40px" }} />
                </Box>
                <Box sx={cn}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: index >= 2 ? "#15513c" : "#777", color: "#Eee" }}>2</Avatar>
                    <Typography sx={{ color: index > 2 ? "#15513c" : "#777" }}>معلومات العقار</Typography>
                    <Divider orientation="vertical" variant="middle" sx={{ bgcolor: index > 2 ? "#15513c" : "#777", height: "40px" }} />
                </Box>

                <Box sx={cn}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: index >= 3 ? "#15513c" : "#777", color: "#Eee" }}>3</Avatar>
                    <Typography sx={{ color: index > 3 ? "#15513c" : "#777" }}>وصف الحالة والأضرار</Typography>
                    <Divider orientation="vertical" variant="middle" sx={{ bgcolor: index > 3 ? "#15513c" : "#777", height: "40px" }} />
                </Box>
                <Box sx={cn}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: index >= 4 ? "#15513c" : "#777", color: "#Eee" }}>4</Avatar>
                    <Typography sx={{ color: index > 4 ? "#15513c" : "#777" }}>طريقة الدعم المطلوبة</Typography>
                    <Divider orientation="vertical" variant="middle" sx={{ bgcolor: index > 4 ? "#15513c" : "#777", height: "40px" }} />
                </Box>
                <Box sx={cn}>
                    <Avatar sx={{ width: 24, height: 24, bgcolor: index >= 5 ? "#15513c" : "#777", color: "#Eee" }}>5</Avatar>
                    <Typography sx={{ color: index > 5 ? "#15513c" : "#777" }}>طريقة التواصل والشروط والأحكام</Typography>
                </Box>
            </Stack>
        </>
    )
}

export default FlowChart